<script>
    import BaseHistoryChart from '../../common/BaseHistoryChart.svelte';

    const incomeDatasets = [
        {
            label: 'Parkeringsintäkter',
            dataKey: 'rental_income_from_parking_spots',
            borderColor: '#5a5a5b',
            pointBackgroundColor: '#5a5a5b',
            fill: true,
            gradientColors: { start: 'rgba(90, 90, 91, 0.4)', stop: 'rgba(90, 90, 91, 0.05)' },
            yAxisID: 'y',
            order: 0,
            tooltipSuffix: ' tkr'
        },
        {
            label: 'Hyresintäkter',
            dataKey: 'rental_income_from_rental_apartments',
            borderColor: '#e7e7e4',
            pointBackgroundColor: '#e7e7e4',
            fill: true,
            gradientColors: { start: 'rgba(231, 231, 228, 0.4)', stop: 'rgba(231, 231, 228, 0.05)' },
            yAxisID: 'y',
            order: 1,
            tooltipSuffix: ' tkr'
        },
        {
            label: 'Lokalintäkter',
            dataKey: 'rental_income_from_commercial_premises',
            borderColor: '#a4a4a4',
            pointBackgroundColor: '#a4a4a4',
            fill: true,
            gradientColors: { start: 'rgba(138, 127, 114, 0.4)', stop: 'rgba(138, 127, 114, 0.05)' },
            yAxisID: 'y',
            order: 2,
            tooltipSuffix: ' tkr'
        }
    ];

    const incomeYAxes = [
        {
            id: 'y',
            title: 'Inkomst (tkr)',
            position: 'left',
        }
    ];
</script>

<BaseHistoryChart
    headerTitle="Inkomstfördelning"
    datasetsConfig={incomeDatasets}
    yAxesConfig={incomeYAxes}
    xAxisTitleText="År"
/>
